import {
  Button,
  ListContainer,
  ListContext,
  NoData,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  formatDate,
  Stack,
  Typography,
} from "@compass/core";

import { Permission, PermissionAction, StudentTest } from "generated/openApi";
import { useRouter } from "hooks";
import "moment-timezone";
import { studentTestPageRoute } from "pages/students/student-tests/StudentTestPage/StudentTestPage";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";

export const Tests = (props: {
  studentId: number;
  year: number | undefined;
  tests: StudentTest[];
  onGetList: () => void;
}) => {
  const ROOT_PERMISSION: Permission = Permission.StudentTest;
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  return (
    <>
      <ListContainer
        header={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">Tests</Typography>

            <Stack direction="row" alignItems="center" spacing="sm">
              {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
                <Button
                  variant="text"
                  onClick={() => {
                    navigate({
                      pathname: studentTestPageRoute.getPath({ id: 0, crudMode: "edit", screenType: "dialog" }),
                      search: studentTestPageRoute.getOptionalParams?.({
                        studentId: props.studentId,
                        schoolYear: props.year,
                      }),
                    });
                  }}
                  sx={{ minWidth: "auto" }}
                >
                  + New
                </Button>
              )}
            </Stack>
          </Stack>
        }
        tableContainer={
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Test Type</TableCell>
                  <TableCell align="right">Score</TableCell>
                  <TableCell>Test Level</TableCell>
                  <TableCell>Test Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.tests.map((test) => (
                  <TableRow
                    key={test.id}
                    onClick={() =>
                      navigate({
                        pathname: studentTestPageRoute.getPath({
                          id: test.id,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                      })
                    }
                  >
                    <TableCell>{test.testType?.name}</TableCell>
                    <TableCell align="right">{test.score}</TableCell>
                    <TableCell>{test.testLevel?.name}</TableCell>
                    <TableCell>{formatDate(test.testDate)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      {matchTemplatePath(studentTestPageRoute.templatePath) && (
        <ListContext.Provider value={{ loadList: () => props.onGetList() }}>
          <Outlet />
        </ListContext.Provider>
      )}
    </>
  );
};
